var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["./foreign-key-buttons.html"] = require( "./foreign-key-buttons.html" );




var shim = require("/app/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["enso_cms/static/enso-cms/nunjucks-templates/widgets/image-asset-widget.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.contextOrFrameLookup(context, frame, "model")) {
output += "\n    <img js-drop-area=\"\" class=\"main-image drop-area\" src=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "imageUrl"), env.opts.autoescape);
output += "\">\n";
;
}
else {
output += "\n    <div js-drop-area class=\"instance-not-set drop-area\"></div>\n";
;
}
output += "\n\n<div class=\"buttons\">\n    ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("./foreign-key-buttons.html", false, "enso_cms/static/enso-cms/nunjucks-templates/widgets/image-asset-widget.html", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
callback(null,t_1);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
callback(null,t_2);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\n    ";
frame = frame.push();
var t_7 = runtime.contextOrFrameLookup(context, frame, "cropButtons");
if(t_7) {var t_5;
if(runtime.isArray(t_7)) {
var t_6 = t_7.length;
for(t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5][0]
frame.set("key", t_7[t_5][0]);
var t_9 = t_7[t_5][1]
frame.set("data", t_7[t_5][1]);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\n        <a href=\"\" ";
output += runtime.suppressValue(t_8, env.opts.autoescape);
output += " class=\"crop-image-btn icon-btn ";
if(runtime.memberLookup((t_9),"cropped")) {
output += "cropped";
;
}
output += "\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((t_9),"label"), env.opts.autoescape);
output += "\">Crop</a>\n    ";
;
}
} else {
t_5 = -1;
var t_6 = runtime.keys(t_7).length;
for(var t_10 in t_7) {
t_5++;
var t_11 = t_7[t_10];
frame.set("key", t_10);
frame.set("data", t_11);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\n        <a href=\"\" ";
output += runtime.suppressValue(t_10, env.opts.autoescape);
output += " class=\"crop-image-btn icon-btn ";
if(runtime.memberLookup((t_11),"cropped")) {
output += "cropped";
;
}
output += "\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((t_11),"label"), env.opts.autoescape);
output += "\">Crop</a>\n    ";
;
}
}
}
frame = frame.pop();
output += "\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["enso_cms/static/enso-cms/nunjucks-templates/widgets/image-asset-widget.html"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./enso_cms/static/enso-cms/nunjucks-templates/widgets/image-asset-widget.html
// module id = ./enso_cms/static/enso-cms/nunjucks-templates/widgets/image-asset-widget.html
// module chunks = main